// BlueMouse GmbH Helpers
import initSelect2 from './helpers/select2.js';
import initDatepicker from './helpers/datepicker.js';
import initPopovers from './helpers/popovers.js';
import {
    initDeleteBtn,
} from './helpers/helper.js';

import pastorsEditAddInit from './pages/pastors.edit-add';
import planningSubmissionsEditAddInit from './pages/planning-submissions.edit-add';
import planningsEditAddInit from './pages/plannings.edit-add';
import planningsShowInit from './pages/plannings.show';

window.pastorsEditAddInit = pastorsEditAddInit;
window.planningSubmissionsEditAddInit = planningSubmissionsEditAddInit;
window.planningsEditAddInit = planningsEditAddInit;
window.planningsShowInit = planningsShowInit;


$(document).ready(function() {
    initSelect2();
    initDeleteBtn();
    initDatepicker();
    initPopovers();

    $('.ckeditor').each(function() {
        // Init the CKEditor
        var editor = ClassicEditor.create(document.querySelector('#' + $(this).attr('id')),  {
            toolbar: ['bold', 'italic', 'bulletedList', 'numberedList']
        })
        .then(editor => {
            // console.log('ready');
        });
    });
});